import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const devopsConnectedProjectRoute: InvariantJiraRoute = {
	name: 'devops-connected-project',
	path: '/jira/devops/connected-project',
};
